import React from "react";
import { PhoneIcon } from "@heroicons/react/solid";
import { PdfPhoneClick } from "@/components/community/PhoneReveal";

const NeedHelpRow = () => {
    return (
        <div className="flex items-center gap-4">
            <span className="text-sm sm:text-xl font-bold font-headline">
                Talk to an Assisted Living Counselor
            </span>
            <a
                href="tel:6127877533"
                className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 rounded-full px-3 py-1"
                onClick={PdfPhoneClick}
            >
                <div className="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
                    <PhoneIcon className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm sm:text-lg font-bold text-gray-700">
                    612-787-7533
                </span>
            </a>
        </div>
    );
};

export default NeedHelpRow;
